import { ClinicCanvasStage } from '../components/ClinicCanvasStage';
import { careModes, type CareModeId } from '../content';
import { useCareMode } from '../context/CareModeContext';

export function CareModesSection() {
  const { modeId, setModeId, mode } = useCareMode();

  const handleModeSelect = (id: CareModeId) => {
    setModeId(id);
  };

  return (
    <section
      id="modes"
      className="relative overflow-hidden bg-neutral-100 py-[var(--section-padding-y)]"
      aria-labelledby="modes-heading"
    >
      <div className="mx-auto max-w-[var(--container-max)] px-[var(--section-padding-x)]">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="section-eyebrow">Care modes</p>
            <h2 id="modes-heading" className="section-title">
              Choose the lens. Watch the stethoscope respond.
            </h2>
            <p className="section-copy max-w-lg">
              Companion, feline, or urgent each shifts the metals and tubing so the tone reads before you walk in.
            </p>

            <div className="mt-10 flex flex-col gap-1" role="tablist" aria-label="Care modes">
              {careModes.map((careMode) => {
                const isSelected = modeId === careMode.id;

                return (
                  <button
                    key={careMode.id}
                    type="button"
                    role="tab"
                    aria-selected={isSelected}
                    onClick={() => handleModeSelect(careMode.id)}
                    className={`border-l-[3px] px-5 py-4 text-left transition-colors duration-300 ${
                      isSelected
                        ? 'bg-paper text-ink shadow-sm'
                        : 'border-l-neutral-300 text-neutral-600 hover:border-l-neutral-400 hover:text-ink'
                    }`}
                    style={
                      isSelected
                        ? { borderLeftColor: careMode.metal, boxShadow: 'var(--shadow-sm)' }
                        : undefined
                    }
                  >
                    <span className="block font-display text-lg font-semibold">{careMode.label}</span>
                    <span className="mt-1 block font-body text-sm text-neutral-500">{careMode.blurb}</span>
                  </button>
                );
              })}
            </div>

            <p className="mt-8 font-body text-sm text-neutral-500" aria-live="polite">
              Active: {mode.label}
            </p>
          </div>

          <div className="stage-frame aspect-square w-full max-w-lg justify-self-center">
            <div className="stage-frame-inner" aria-hidden="true" />
            <ClinicCanvasStage compact pointerEnabled />
          </div>
        </div>
      </div>
    </section>
  );
}
